import React from "react";
import {
  Box,
  Button,
  Backdrop,
  TextField,
  IconButton,
  CircularProgress
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import agent from "../../../../../agent/agent";
import {useDispatch, useSelector} from "react-redux";
import {LoadingContent, VisibleContent} from "../../../../../components";
import rateConvert from "../../../../../utils/rateConvert";
import {notification, notificationTypes} from "../../../../../utils/notification";
import {getUser} from "../../../../../redux/stores/profile";
import {addToClipboard} from "../../../../../utils/clipboard";
import getTrans from "../../../../../languages/getTrans";

let timeoutCheckMoney = null;
const UsdtTrc20 = ({ paymentDetail }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = useSelector(state => state.profile.user);
  const [isBackdrop, setIsBackdrop] = React.useState(false);

  const minAmount = rateConvert(paymentDetail?.minValue, {useSybmol: true});
  const commission = `${paymentDetail?.commissionPercentage} %`;

  const [userTelegram, setUserTelegram] = React.useState('');
  const handleChangeUserTelegram = ({target}) => {
    setUserTelegram(target?.value || '');
  }
  const handleSubmitUserTelegram = async () => {
    setIsBackdrop(true);
    await agent.put('/api/users/settings', {settings: {telegram: userTelegram}}).then(() => true).catch(() => false);
    dispatch(getUser());
    setIsBackdrop(false);
    notification({type: notificationTypes.success, message: getTrans('usdtTrc20.Telegram пользователя успешно обновлен')})
  }

  const [isLoading, setIsLoading] = React.useState(true);
  const [isHashWallet, setHashWallet] = React.useState(true);
  const [iconWallet, setIconWallet] = React.useState('');
  const [addressWallet, setAddressWallet] = React.useState('');
  const initState = async () => {
    const hashWallet = await agent.get(`/api/tron/has-wallet`).then((res) => res.data?.result || false).catch(() => false);
    setUserTelegram(user?.settings?.telegram || '');
    if (!hashWallet) {
      setHashWallet(false);
      setIsLoading(false);
      return
    }
    const resAddressWallet = await agent.get('/api/tron/get-wallet').then((res) => res.data?.address || '').catch(() => '');
    setAddressWallet(resAddressWallet);

    const resIconWallet = await agent.get('/api/tron/qr', { responseType: 'arraybuffer' })
      .then((res) => {
        const mime = (res.headers && (res.headers['content-type'] || res.headers['Content-Type'])) || 'image/png';
        const blob = new Blob([res.data], { type: mime });
        return URL.createObjectURL(blob);
      })
      .catch(() => "")
    setIconWallet(resIconWallet);

    setIsLoading(false);
  };
  const handleGenerateAddress = async () => {
    await setIsLoading(true);
    await agent.get(`/api/tron/get-wallet`).then((res) => res.data?.result || false).catch(() => false);
    await initState();
  }
  const handleCopyWalletAddress = async () => {
    await addToClipboard(addressWallet);
    notification({type: notificationTypes.success, message: getTrans('usdtTrc20.Copied to clipboard')})
  }
  React.useEffect(() => {
    (async () => {
      await initState();
    })();
  }, []);

  const [statusCheckMoney, setStatusCheckMoney] = React.useState(-1);
  const handleCheckMoney = async () => {
    clearTimeout(timeoutCheckMoney);
    const res = await agent.post('/api/tron/check-wallet', {}).then((res) => res.data.balance_updated || false).catch(() => false);
    setStatusCheckMoney(Number(res));
    timeoutCheckMoney = setTimeout(() => {
      setStatusCheckMoney(-1);
    }, 1.5 * 1000);
  }

  const [isTemplateHistory, setTemplateHistory] = React.useState(false);
  const [dataHistory, setDataHistory] = React.useState(null);
  const handleTemplateHistory = async () => {
    const _value = !isTemplateHistory;
    setTemplateHistory(!isTemplateHistory);
    if (!_value) {
      setDataHistory(null);
      return
    }

    const res = await agent.get('/api/tron/pending-status')
      .then((res) => res.data).catch(() => [])
    setDataHistory({
      ...res,
      progressPercentage: res?.min_credit_amount > 0 ? Math.min(100, Math.ceil((res?.pending_sum / res?.min_credit_amount) * 100)) : 0
    })
  }

  const getFormatValueForHistory = (value) => {
    if (!value) return '0 USDT (0$)';
    return `${value} USDT (${value}$)`;
  }

  if (isLoading) {
    return (<LoadingContent/>)
  }
  if (!isHashWallet) {
    return (
      <div className={classes.root}>
        <div className={classes.infoRow}>
          <span className={classes.infoLabel}>{getTrans('usdtTrc20.Minimum payment amount')}:</span>
          <span className={classes.infoValue}>{minAmount}</span>
        </div>
        <div className={classes.infoRow}>
          <span className={classes.infoLabel}>{getTrans('usdtTrc20.Commission')}:</span>
          <span className={classes.infoValue}>{commission}</span>
        </div>

        <Box mt={3}/>
        <div className={classes.telegramSection}>
        <span className={classes.telegramText}>
          {getTrans('usdtTrc20.Рекомендуем актуализировать ваш контакт в Telegram')}:
        </span>
          <div className={classes.telegramContact}>
            <span className={classes.contactName}>{userTelegram}</span>
            <Button variant="contained" className={classes.okButton}>
              {getTrans('usdtTrc20.OK')}
            </Button>
          </div>
        </div>
        <div className={classes.supportSection}>
          <span className={classes.supportLabel}>{getTrans('usdtTrc20.Поддержка для оптовых клиентов')}:</span>
          <a href="https://t.me/vipGrizzly" target="_blank" className={classes.supportLink}>{getTrans('usdtTrc20.Telegram link')}</a>
        </div>

        <Box mt={3}/>
        <Button
          fullWidth={true}
          variant="contained"
          onClick={handleGenerateAddress}
          className={classes.generateButton}
        >{getTrans('usdtTrc20.Сгенерировать')}</Button>
      </div>
    )
  }
  if (isTemplateHistory) {
    return (
      <div className={classes.root}>
        <div className={classes.infoRow}>
          <span className={classes.infoLabel}>{getTrans('usdtTrc20.Minimum payment amount')}:</span>
          <span className={classes.infoValue}>{minAmount}</span>
        </div>
        <div className={classes.infoRow}>
          <span className={classes.infoLabel}>{getTrans('usdtTrc20.Commission')}:</span>
          <span className={classes.infoValue}>{commission}</span>
        </div>

        <VisibleContent visible={Boolean(dataHistory)}>
          <div className={classes.historyItems}>
            <div className={classes.historyCard}>
              {dataHistory?.has_pending && (
                <div className={classes.historyHeader}>
                  <span className={classes.historyStatus}>{getTrans('usdtTrc20.Pending')}</span>
                  <span className={classes.historyStatusText}>{getTrans('usdtTrc20.Payment awaiting confirmation')}</span>
                </div>
              )}

              <div className={classes.historyValuesContainer}>
                <div className={classes.historyInfoRow}>
                  <span className={classes.historyInfoLabel}>{getTrans('usdtTrc20.Already sent')}:</span>
                  <span className={classes.historyInfoValue}>
                    {getFormatValueForHistory(dataHistory?.pending_sum)}
                  </span>
                </div>

                <div className={classes.historyDivider}/>

                <div className={classes.historyInfoRow}>
                  <span className={classes.historyInfoLabel}>{getTrans('usdtTrc20.Remaining to minimum')}:</span>
                  <span className={classes.historyInfoValue}>
                    {getFormatValueForHistory(dataHistory?.remaining_to_credit)}
                  </span>
                </div>

                <div className={classes.historyDivider}/>

                <div className={classes.historyInfoRow}>
                  <span className={classes.historyInfoLabel}>{getTrans('usdtTrc20.Minimum required')}:</span>
                  <span className={classes.historyInfoValue}>
                    {getFormatValueForHistory(dataHistory?.min_credit_amount)}
                  </span>
                </div>
              </div>

              {dataHistory?.has_pending && (
                <>
                  <div className={classes.progressBarContainer}>
                    <div className={classes.progressBar}>
                      <div
                        className={classes.progressBarFill}
                        style={{ width: `${dataHistory?.progressPercentage || 0}%` }}
                      ></div>
                    </div>
                    <span className={classes.progressText}>
                      {dataHistory?.progressPercentage || 0}% {getTrans('usdtTrc20.of required amount recieved')}
                    </span>
                  </div>

                  <div className={classes.historyFooterText}>
                    {getTrans('usdtTrc20.Please send the remaining amount to complete this payment. Funds will be credited within 5 minutes after confirmation.')}
                  </div>
                </>
              )}

              <div className={classes.historyButtonContainer}>
                <Button
                  variant="outlined"
                  className={classes.historyCloseButton}
                  onClick={handleTemplateHistory}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.6665 14.2167H9.99984" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M3.51648 11.25H8.14986C9.63319 11.25 9.99984 11.6167 9.99984 13.0833V16.5083C9.99984 17.975 9.63319 18.3417 8.14986 18.3417H3.51648C2.03315 18.3417 1.6665 17.975 1.6665 16.5083V13.0833C1.6665 11.6167 2.03315 11.25 3.51648 11.25Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M18.3333 12.5C18.3333 15.725 15.725 18.3333 12.5 18.3333L13.375 16.875" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M1.6665 7.50002C1.6665 4.27502 4.27484 1.66669 7.49984 1.66669L6.62485 3.12502" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M15.4165 9.16669C17.4876 9.16669 19.1665 7.48775 19.1665 5.41669C19.1665 3.34562 17.4876 1.66669 15.4165 1.66669C13.3454 1.66669 11.6665 3.34562 11.6665 5.41669C11.6665 7.48775 13.3454 9.16669 15.4165 9.16669Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {getTrans('usdtTrc20.Закрыть историю')}
                </Button>
              </div>
            </div>
          </div>
        </VisibleContent>
        <VisibleContent visible={Boolean(!dataHistory)}>
          <LoadingContent/>
        </VisibleContent>
      </div>
    )
  }
  return (
    <div className={classes.root}>
      <div className={classes.infoRow}>
        <span className={classes.infoLabel}>{getTrans('usdtTrc20.Minimum payment amount')}:</span>
        <span className={classes.infoValue}>{minAmount}</span>
      </div>
      <div className={classes.infoRow}>
        <span className={classes.infoLabel}>{getTrans('usdtTrc20.Commission')}:</span>
        <span className={classes.infoValue}>{commission}</span>
      </div>

      <div className={classes.walletSection}>
        <div className={classes.walletHeader}>
          <span className={classes.walletLabel}>{getTrans('usdtTrc20.Your wallet')}</span>
        </div>
        <div className={classes.walletAddress} onClick={handleCopyWalletAddress}>
          {addressWallet}
          <IconButton className={classes.copyIcon}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M13.5 2H4.5C3.67 2 3 2.67 3 3.5V14.5H4.5V3.5H13.5V2ZM16 5H7C6.17 5 5.5 5.67 5.5 6.5V17.5C5.5 18.33 6.17 19 7 19H16C16.83 19 17.5 18.33 17.5 17.5V6.5C17.5 5.67 16.83 5 16 5ZM16 17.5H7V6.5H16V17.5Z" fill="#FB7800"/>
            </svg>
          </IconButton>
        </div>
      </div>

      <div className={classes.qrSection}>
        <div className={classes.qrCode}>
          <img src={iconWallet} className={classes.qrPlaceholder}/>
        </div>
      </div>

      <div className={classes.warningBox}>
        <span className={classes.warningIcon}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="1.5"/>
            <path d="M10 6V11M10 14V14.5" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </span>
        <span className={classes.warningText}>
          {getTrans('usdtTrc20.Все средства, отправленные на этот адрес, будут зачислены на транзакцию аккаунта Grizzly SMS в течение 5 минут после подтверждения транзакции.')}
        </span>
      </div>

      <div className={classes.usdtInfo}>
        {getTrans('usdtTrc20.Адрес предназначен исключительно для USDT в сети TRC-20. Переводы другими токенами или через другие сети не принимаются и будут безвозвратно утеряны.')}
      </div>

      <VisibleContent visible={statusCheckMoney > -1}>
        <div className={classes.statusBox}>
          <div className={classes.statusIcon}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9" stroke="#FB7800" strokeWidth="1.5"/>
              <path d="M10 6V11M10 14V14.5" stroke="#FB7800" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </div>
          <span className={classes.statusText}>
            {statusCheckMoney === 1 ? getTrans('usdtTrc20.Средства зачислены') : getTrans('usdtTrc20.Средства не зачислены')}
          </span>
        </div>
      </VisibleContent>
      <Button
        fullWidth
        variant="contained"
        className={classes.checkButton}
        onClick={handleCheckMoney}
      >
        {getTrans('usdtTrc20.Проверить')}
      </Button>

      <div className={classes.telegramSection}>
        <span className={classes.telegramText}>
          {getTrans('usdtTrc20.Рекомендуем актуализировать ваш контакт в Telegram')}:
        </span>
        <div className={classes.telegramContact}>
          <TextField
            fullWidth={true}
            value={userTelegram}
            className={classes.contactName}
            onChange={handleChangeUserTelegram}
            variant="standard"
            placeholder={getTrans('usdtTrc20.@username')}
            InputProps={{
              disableUnderline: true,
            }}
          />
          <Button variant="contained" className={classes.okButton} onClick={handleSubmitUserTelegram}>
            {getTrans('usdtTrc20.OK')}
          </Button>
        </div>
      </div>
      <div className={classes.supportSection}>
        <span className={classes.supportLabel}>{getTrans('usdtTrc20.Поддержка для оптовых клиентов')}:</span>
        <a href="https://t.me/vipGrizzly" target="_blank" className={classes.supportLink}>{getTrans('usdtTrc20.Telegram link')}</a>
      </div>

      <div className={classes.buttonTransactionsHistory}>
        <Button
          variant="outlined"
          onClick={handleTemplateHistory}
          className={classes.historyCloseButton}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.6665 14.2167H9.99984" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.51648 11.25H8.14986C9.63319 11.25 9.99984 11.6167 9.99984 13.0833V16.5083C9.99984 17.975 9.63319 18.3417 8.14986 18.3417H3.51648C2.03315 18.3417 1.6665 17.975 1.6665 16.5083V13.0833C1.6665 11.6167 2.03315 11.25 3.51648 11.25Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18.3333 12.5C18.3333 15.725 15.725 18.3333 12.5 18.3333L13.375 16.875" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1.6665 7.50002C1.6665 4.27502 4.27484 1.66669 7.49984 1.66669L6.62485 3.12502" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.4165 9.16669C17.4876 9.16669 19.1665 7.48775 19.1665 5.41669C19.1665 3.34562 17.4876 1.66669 15.4165 1.66669C13.3454 1.66669 11.6665 3.34562 11.6665 5.41669C11.6665 7.48775 13.3454 9.16669 15.4165 9.16669Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          {isTemplateHistory ? getTrans('usdtTrc20.Закрыть историю') : getTrans('usdtTrc20.История транзакций')}
        </Button>
      </div>

      <Backdrop open={isBackdrop}>
        <CircularProgress/>
      </Backdrop>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    padding: '0',
    marginTop: "26px",
    paddingBottom: "50px",
  },

  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  infoLabel: {
    fontSize: '14px',
    linHeight: '18px',
    color: '#E3E3E3',
  },
  infoValue: {
    fontSize: '15px',
    linHeight: '18px',
    color: 'white',
    fontWeight: '500',
  },

  walletSection: {
    marginTop: '20px',
    marginBottom: '20px',
  },
  walletHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
  walletLabel: {
    fontSize: '16px',
    lineHeight: '20px',
    color: '#FB7800',
    fontWeight: '500',
  },
  walletAddress: {
    fontSize: '16px',
    color: 'white',
    wordBreak: 'break-all',
    lineHeight: '20px',
  },

  copyIcon: {
    padding: '4px',
    '&:hover': {
      background: 'rgba(251, 120, 0, 0.1)',
    },
  },

  qrSection: {
    display: 'flex',
    justifyContent: 'center',
    margin: '24px 0',
  },
  qrCode: {
    width: '200px',
    height: '200px',
    background: 'white',
    borderRadius: '8px',
    padding: '8px',
  },
  qrPlaceholder: {
    width: '100%',
    height: '100%',
  },

  warningBox: {
    gap: '12px',
    marginBottom: '16px',
  },
  warningIcon: {
    position: 'relative',
    "& svg": {
      marginRight: "4px",
      marginBottom: "-4px",
    }
  },
  warningText: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.7)',
    lineHeight: '20px',
  },

  usdtInfo: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.7)',
    lineHeight: '20px',
    marginBottom: '16px',
  },

  statusBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    height: 34,
    padding: '6px 16px',
    background: '#30353E',
    borderRadius: '8px',
    marginBottom: '16px',
  },
  statusIcon: {
    flexShrink: 0,
  },
  statusText: {
    fontSize: '14px',
    color: '#FB7800',
    fontWeight: '500',
  },
  checkButton: {
    height: '44px',
    background: 'transparent!important',
    fontSize: '18px',
    fontWeight: '500',
    color: 'white!important',
    borderRadius: '12px',
    textTransform: 'none',
    border: '1px solid #FB7800!important',
    marginBottom: '24px'
  },
  generateButton: {
    height: '44px',
    fontSize: '18px',
    fontWeight: '500',
    color: 'white!important',
    borderRadius: '12px',
    textTransform: 'none',
    marginBottom: '24px'
  },


  telegramSection: {
    marginBottom: '16px',
  },
  telegramText: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.7)',
    display: 'block',
    marginBottom: '8px',
  },
  telegramContact: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 8px 8px 16px',
    background: '#30353E',
    borderRadius: '8px',
  },

  contactName: {
    flex: 1,

    '& .MuiInputBase-root': {
      fontSize: '18px',
      color: 'white',
      background: 'transparent',

      '&:before, &:after': {
        display: 'none',
      },
    },

    '& .MuiInputBase-input': {
      padding: '0',
      fontSize: '18px',
      color: 'white',
      lineHeight: '24px',

      '&::placeholder': {
        color: 'rgba(255, 255, 255, 0.4)',
        opacity: 1,
      },
    },

    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
      },
    },
  },
  okButton: {
    height: '40px',
    minWidth: '64px',
    background: '#FB7800!important',
    fontSize: '16px',
    fontWeight: '600',
    color: 'white!important',
    borderRadius: '8px',
    textTransform: 'none',
    padding: '0 20px',
    flexShrink: 0,

    '&:hover': {
      background: '#E86F00!important',
    },
  },
  supportSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
    marginTop: '12px',
  },
  supportLabel: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  supportLink: {
    fontSize: '14px',
    color: '#00A3E0',
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'underline',
    },
  },

  buttonTransactionsHistory: {
    display: 'flex',
    marginTop: "32px",
    alignItems: 'center',
    justifyContent: 'center',

    "& .MuiButtonBase-root": {
      height: 40,
      border: "none",
      padding: "0px 32px",
      borderRadius: '8px',
      backgroundColor: '#FB780033!important',

      color: "white",
      fontSize: '16px',
    }
  },

  historyItems: {
    marginTop: '24px',
  },
  historyCard: {},
  historyHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  historyStatus: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#FB7800',
  },
  historyStatusText: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  historyValuesContainer: {
    marginBottom: '16px',
  },
  historyInfoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
  },
  historyDivider: {
    width: '100%',
    height: '1px',
    background: 'rgba(255, 255, 255, 0.1)',
    margin: '4px 0',
  },
  historyInfoLabel: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.6)',
  },
  historyInfoValue: {
    fontSize: '15px',
    fontWeight: '500',
    color: 'white',
  },
  progressBarContainer: {
    marginTop: '20px',
    marginBottom: '16px',
  },
  progressBar: {
    width: '100%',
    height: '28px',
    background: '#30353E',
    borderRadius: '8px',
    overflow: 'hidden',
    position: 'relative',
    marginBottom: '8px',
    border: "1px solid #FB7800",
  },
  progressBarFill: {
    height: '100%',
    background: 'repeating-linear-gradient(45deg, #FB7800, #FB7800 10px, #FF8A1A 10px, #FF8A1A 20px)',
    transition: 'width 0.3s ease'
  },
  progressText: {
    fontSize: '13px',
    color: 'white',
    display: 'block',
    textAlign: 'center',
  },
  historyFooterText: {
    fontSize: '13px',
    lineHeight: '18px',
    color: 'rgba(255, 255, 255, 0.7)',
    textAlign: 'center',
    marginTop: '12px',
    marginBottom: '20px',
  },
  historyButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '24px',
  },
  historyCloseButton: {
    height: '40px',
    padding: '0 24px',
    border: 'none!important',
    borderRadius: '8px',
    backgroundColor: 'rgba(251, 120, 0, 0.2)!important',
    color: 'white!important',
    fontSize: '16px',
    fontWeight: '500',
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',

    '& svg': {
      flexShrink: 0,
    },

    '&:hover': {
      backgroundColor: 'rgba(251, 120, 0, 0.3)!important',
    },
  },
  historyItemStatus: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

export default UsdtTrc20;
